import { Injectable } from '@angular/core';
import { ProjectFloorPoint } from '../../../../models/project.model';
import { Subject } from 'rxjs';
import { RestfulEndpoint } from '../../../../services/restful-endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  selectedPoint: ProjectFloorPoint;
  selectedSplitPoint: ProjectFloorPoint;
  private mapSplitSubject = new Subject<any>();
  private navigationSubject = new Subject<'next' | 'previous'>();
  private splitReportRequestSubject = new Subject<string | null>();
  navigation$ = this.navigationSubject.asObservable();
  // Observable to listen to function call from other components
  mapSplitObservable$ = this.mapSplitSubject.asObservable();
  splitReportRequest$ = this.splitReportRequestSubject.asObservable();
  public reportList: any;

  constructor(private endPoint: RestfulEndpoint) {}

  // Function to trigger the method in other components
  triggerPrepareMapSplit(floor: any, update: boolean = false, opened: boolean = false): void {
    setTimeout(() => {
      this.mapSplitSubject.next({ floor, update, opened });
    }, 1000);
  }

  navigate(direction: 'next' | 'previous') {
    this.navigationSubject.next(direction);
  }

  requestSplitReport(reportId?: string): void {
    this.splitReportRequestSubject.next(reportId || null);
  }

  async fetchReports(projectId: string, per_page = 20, page = 1) {
    try {
      const params = new URLSearchParams();
      params.append('per_page', per_page.toString());
      params.append('page', page.toString());
      this.reportList = await this.endPoint
        .get(`projects/${projectId}/reports?${params.toString()}`)
        .toPromise();
      return this.reportList.data;
    } catch (e) {
      return null;
    }
  }
}
